import React from 'react';
import { View, Text, Pressable } from 'react-native';

const VisitorViewBanner = ({ onReturn }) => {
	return (
		<View style={{
			position: 'fixed',
			bottom: 0,
			left: 0,
			right: 0,
			backgroundColor: '#4c956c',
			paddingVertical: 12,
			paddingHorizontal: 20,
			zIndex: 10000,
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
		}}>
			<Text style={{
				fontFamily: 'Orpheus Pro',
				color: '#fefde2',
				fontSize: 14,
				fontWeight: '600',
			}}>
				Viewing as visitor
			</Text>
			<Pressable
				onPress={onReturn}
				style={{
					position: 'absolute',
					right: 20,
					paddingVertical: 6,
					paddingHorizontal: 14,
					borderRadius: 20,
					backgroundColor: 'rgba(254,253,226,0.2)',
				}}
			>
				<Text style={{
					fontFamily: 'Orpheus Pro',
					color: '#fefde2',
					fontSize: 13,
				}}>
					Return to owner view
				</Text>
			</Pressable>
		</View>
	);
};

export default VisitorViewBanner;
